<template>
  <div class="animated fadeIn">
    <h2 class="cc-title">Main</h2>
    <div class="row admin-master-page mb-4">
      <b-col cols="12">
        <latest-file-cards />

        <div v-if="getterUserInfo" class="trans-associated-container">
          <TransactionAssociated :canDownloadFile="true" />
        </div>
      </b-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GETTER_USER_INFO } from "@/store/modules/users/constants";
import LatestFileCards from "@/components/dashboard/LatestFileCards";
import TransactionAssociated from "@/components/transaction-associated/TransactionAssociated";
export default {
  name: "admin-home",
  components: {
    LatestFileCards,
    TransactionAssociated
  },
  computed: {
    ...mapGetters({
      getterUserInfo: GETTER_USER_INFO
    })
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/_core-variables";

.admin-master-page {
  padding: 15px 0;
  border-radius: 4px;
  background-color: $white;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/admin/Home.vue